import { render, staticRenderFns } from "./FutureAddress.vue?vue&type=template&id=79259b6c&"
import script from "./FutureAddress.vue?vue&type=script&lang=ts&"
export * from "./FutureAddress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports